import React, { Component } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';

import { getFactionTextureUrl } from '../../../Common/TextureTools';
import ScoreBars from '../ScoreBars';
import { DefaultEventComponent } from './Default';

class FactionIcon extends Component {
    render() {
        let textureUrl;
        let factionId = this.props.factionId;
        textureUrl = getFactionTextureUrl(factionId);
        return <div id={'scoring-faction-icon'}>
            <img
                src={textureUrl}
                alt="faction"
                style={{ width: '30px' }}
            />
        </div>;
    }
}


// 2026-05-16: EndOfGameReport used to be rendered inside the generic
// DefaultEventModal, which (a) auto-closed after the event's
// display_time and (b) dismissed itself on any body click. End-of-game
// is the one event where neither of those is OK — the player wants to
// linger on the final score. So this component renders its OWN Modal,
// ignores `eventComplete` until the user explicitly clicks "Return to
// Play", and only then runs gameOverPusher (which navigates back to
// /play).
//
// 2026-05-16 (afternoon): An earlier rev of this file had a
// `componentWillUnmount` fallback that called `gameOverPusher()`
// whenever the component unmounted without `this.dismissed` being
// set. The intent was "if we get torn down by a route change or hot
// reload, still clean up the game group." That fallback was a
// footgun on TWO axes:
//
//   1. React 19 StrictMode dev double-invokes lifecycle methods on
//      the SAME instance (mount → unmount → mount). The first
//      unmount fired the fallback before the user could see
//      anything, calling gameOverPusher → leaveGameGroup +
//      navigate('/play'). The route changed before the second
//      mount could render the modal visibly. (Same trap that bit
//      `GameComponent` and `FullscreenToggle` on 2026-05-14.)
//   2. Even in production, calling `gameOverPusher` from unmount
//      doesn't just clean up — it FORCES navigation to /play. If
//      the user navigated away by Esc, route, or any other means,
//      that explicit navigation could override their actual
//      destination.
//
// Resolution: remove the unmount fallback. The "Return to Play"
// button is now the single path that fires `gameOverPusher`. If
// the user leaves the End-of-Game screen by other means, the
// WebSocket group membership leaks for one cycle — that's a tiny,
// non-functional leak that's properly cleaned up the next time the
// player connects to a different game. If we want a more thorough
// cleanup at GameComponent-unmount time, that belongs on
// GameComponent itself, not here.
export default class EndOfGameReport extends DefaultEventComponent {

    constructor(props) {
        super(props);
        this.state = { show: true };
    }

    componentDidMount() {
        // Belt-and-suspenders: EventRouter.filterEvent already fires
        // drainQueue when event 29 arrives, but if EOG ever mounts via
        // a different path (route replay, future cache rehydration),
        // drain again here. drainQueue itself is idempotent on the
        // gameEnded flag, so a second call is a no-op.
        const gc = this.props.app && this.props.app.gameController;
        if (gc && typeof gc.drainQueue === 'function') {
            gc.drainQueue();
        }
    }

    dismiss = () => {
        console.log('[postgame-fp] EndOfGameReport.dismiss clicked '
            + 'hasGame=%s hasGameApi=%s',
            !!(this.props.app && this.props.app.game),
            !!(this.props.app && this.props.app.game
                && this.props.app.game.gameApi));
        this.setState({ show: false });
        this.props.app.game.gameOverPusher();
    }

    render() {
        let scoreData = this.props.receivedMessage.package.data;
        let gamePlayers = scoreData.gameplayer_set;
        let gameStats = scoreData.game_stats;

        const WIN_ID = 5;
        const TIED_ID = 31;

        return <Modal
            show={this.state.show}
            backdrop="static"
            keyboard={false}
            animation
            centered
            scrollable
            className={'event-modal'}
            contentClassName={'event-modal-content'}
            aria-labelledby="end-of-game-title"
        >
            <Modal.Header className={'event-modal-header'}>
                <Modal.Title id="end-of-game-title">
                    End of Game
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'event-modal-body'}>
                <Row><ScoreBars {...this.props} gameData={scoreData}/></Row>
                <Row>Length: {gameStats.total_game_length_in_seconds}s</Row>
                <Row>Rounds Played: {gameStats.rounds_played}</Row>
                <Row>Turns Played: {gameStats.turns_played}</Row>
                <Row>Actions Taken: {gameStats.actions_taken}</Row>

                <Table style={{color: 'white'}}>
                    <thead>
                    <tr>
                        <th>Faction</th>
                        <th>Player</th>
                        <th>State</th>
                        <th>Current Score</th>
                    </tr>
                    </thead>
                    <tbody>
                    {gamePlayers.map((gamePlayer, index) => {
                        return <tr key={index}>
                            <td><FactionIcon factionId={gamePlayer.faction}/></td>
                            <td>{gamePlayer.name}</td>
                            <td>
                                {gamePlayer.status === WIN_ID && <span>WINNER</span>}
                                {gamePlayer.status === TIED_ID && <span>TIED</span>}
                            </td>
                            <td>{gamePlayer.current_score}</td>
                        </tr>;
                    })}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer className={'event-modal-footer'}>
                <Button variant={'deep'} onClick={this.dismiss}>
                    Return to Play
                </Button>
            </Modal.Footer>
        </Modal>;
    }

}
